module.exports = __webpack_public_path__ + "static/img/question.44a6f3a8.svg";